import { Component, ReactNode } from 'react';
import { AdminApi } from '../admin-api';

import { useNavigate } from 'react-router';
import 'react-toastify/dist/ReactToastify.css';
import LoadingButton from './LoadingButton';
import PageLoading from './PageLoading';

export default function Login() {
  return <LoginComp navigate={useNavigate()} />;
}

class LoginComp extends Component {
  constructor(readonly props: Readonly<{ navigate?: any }>) {
    super(props);
    this.state = {
      email: '',
      password: '',
      isSubmitting: false,
      isAuthenticated: false,
      isLoading: true,
    };
  }

  state: Readonly<{
    email: string;
    password: string;
    isSubmitting: boolean;
    isAuthenticated: boolean;
    isLoading: boolean;
  }>;

  async componentDidMount(): Promise<void> {
    const _data = await AdminApi.get('/session');

    if (_data) {
      this.props.navigate('/calendar', { replace: true });
    } else {
      this.setState({ isLoading: false });
    }
  }

  async login() {
    this.setState({ isSubmitting: true });

    const _r = await AdminApi.post('/login', {
      email: this.state.email,
      password: this.state.password,
    });

    if (_r) {
      this.props.navigate('/calendar', { replace: true });
    }

    this.setState({ isSubmitting: false });
  }

  buttonIsEnabled() {
    return this.state.email.length > 0 && this.state.password.length > 0;
  }

  render(): ReactNode {
    if (this.state.isLoading) {
      return <PageLoading></PageLoading>;
    } else if (this.state.isAuthenticated) {
      return <div>Redirecionando...</div>;
    }

    return (
      <main
        className="form-signin w-100 m-auto"
        style={{ maxWidth: '400px', padding: '1rem' }}
      >
        <form>
          <img
            className="mb-4"
            src="/assets/img/logo.png"
            alt=""
            width="72"
            height="57"
          />
          <h1 className="h3 mb-3 fw-normal">Informe seus dados de acesso</h1>

          <div className="form-floating">
            <input
              type="email"
              className="form-control"
              id="floatingInput"
              placeholder="name@example.com"
              onChange={(e) => this.setState({ email: e.target.value })}
            />
            <label>E-mail</label>
          </div>
          <div className="form-floating">
            <input
              type="password"
              className="form-control"
              id="floatingPassword"
              placeholder="Password"
              onChange={(e) => this.setState({ password: e.target.value })}
            />
            <label>Senha</label>
          </div>

          <button
            className="btn btn-primary w-100 py-2 my-3"
            type="submit"
            disabled={this.state.isSubmitting || !this.buttonIsEnabled()}
            onClick={() => this.login()}
          >
            {this.state.isSubmitting ? <LoadingButton /> : 'Entrar'}
          </button>
        </form>
      </main>
    );
  }
}
